import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

const NextMonthRevenue = ({ size }) => {
  const { label, value, url, tooltip } = useSelector(
    (state) => state.membershipRevenue.membershipDraft?.autopays?.nextMonthRevenue
  );
  const currencySymbol = useSelector(
    (state) => state.membershipRevenue?.membershipDraft?.currencySymbol
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <DataDisplay
      label={label}
      size={size}
      toolTipContent={tooltip || ""}
      type="money"
      url={url}
      currency={currencySymbol}
      value={value}
      disableAnimation={isUserQa}
    />
  );
};

export default NextMonthRevenue;
